<template>
    <div class="list-group-match-result-wrap tournament-sub-detail-wrap" v-if="!loadingCheck">
        <div class="tournament-title-wrap">
            <p class="tournament-title">{{tournament.tnmtName}}</p>
            <div class="change-btn-wrap" v-if="$route.query.type === 'GT'">
                <p class="chang-btn selected">예선</p>
                <p class="chang-btn"  @click="$router.push({path: `/tournament/${$route.params.tnmtId}/figure/tournament/${$route.params.playingCategoryId}`, query: $route.query})">본선</p>
            </div>
        </div>

        <!--<div class="tournament-type-change-btn" v-if="$route.query.type === 'GT'"
             @click="$router.push({path: `/tournament/${$route.params.tnmtId}/figure/tournament/${$route.params.playingCategoryId}`, query: $route.query})">
            본선 보기
        </div>-->
        <div class="group-list-wrap" v-if="!loadingCheck">
            <div>
                <p class="group" v-for="(group) in groups.tnmgGroupList" :key="group.groupId"
                   :class="Number(groupId) === group.groupId ? 'active' : ''" @click="changeGroupId(group.groupId)">
                    {{group.groupName}}</p>
            </div>
        </div>
        <MatchListTable :participation_list="matches.participantList"></MatchListTable>
        <GroupRanking :group_id="groupId"></GroupRanking>
        <FixtureDetailMatchList></FixtureDetailMatchList>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import MatchListTable from "./MatchListTable";
    import GroupRanking from "./GroupRanking";
    import FixtureDetailMatchList from "./FixtureDetailMatchList";

    export default {
        components: {MatchListTable, GroupRanking, FixtureDetailMatchList},
        computed: {
            ...mapState('tournaments', ['tournament', 'groups', 'matches', 'ranks'])
        },
        data() {
            return {
                groupId: this.$route.query.groupId || null,
                loadingCheck: false
            }
        },
        created() {
            this.loadingCheck = true
            if (this.groups && this.groups.tnmgGroupList.length > 0) {
                if (!this.groupId) {
                    this.groupId = this.groups.tnmgGroupList[0].groupId
                }
                const params = this.$route.params

                const _this = this
                this.$store.dispatch('tournaments/listGroupMatchResult',
                    Object.assign({}, params, {groupId: this.groupId})).then(() => {
                    _this.loadingCheck = false
                    this.$store.dispatch('tournaments/getListGroupRankResult', Object.assign({}, params, {groupId: this.groupId})).then(() => {
                    _this.loadingCheck = false
                    })
                }).catch(() => {
                    _this.loadingCheck = false
                })
                _this.loadingCheck = true
                
            } else {
                this.loadingCheck = false
            }


        },
        methods: {
            changeGroupId(groupId) {
                let query = this.$route.query
                query = Object.assign({}, query, {groupId: groupId})
                this.$router.replace({path: this.$route.path, query: query})
            },
        }
    }
</script>
